// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"aa8dd148","509":"8ee7735c","985":"69bcaff2"}[chunkId] + ".chunk.js";
};